import { Box, Typography } from "@mui/material";
import React from "react";

const InvoiceFooter = ({ data }) => {
  return (
    <>
      {" "}
      <Box
        sx={{
          my: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: "grey" }}>
          Customer Signature
        </Typography>
        <Typography sx={{ fontSize: 16, mt: 5 }}>
          .......................................
        </Typography>
      </Box>
      <Box sx={{ mb: 0 }}>
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: "grey" }}>
          Note
        </Typography>
        <Typography sx={{ fontSize: 16 }}>{data?.note ?? "-"}</Typography>
      </Box>
    </>
  );
};

export default InvoiceFooter;
